import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import KpiTrackerIcon from '../../atoms/Icons/KpiTracker';
import kpiTrackerMessages from '../../../core-utils/messages/kpiTrackerMessages';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import Switch from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Switch';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';
import {
  Add,
  Button,
  DatePicker,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { useStores } from '../../../stores';
import { combineTimeMarkers } from '../../../core-utils/helper-utils/kpiTrackerHelper';

export interface KpiValueInterface {
  name: string;
  values: string[];
  isChecked: boolean;
   
  handleChange: (program: string, index: number) => void;
  selectedValues: string[];
   
  handleSelectedValues: (program: string, index: number, kpis: any) => void;
}
export interface KpiProgramInterface {
  program: string;
  Kpis: KpiValueInterface[];
}
export interface KpiTrackerProps {
  kpiPrograms: KpiProgramInterface[];
   
  handleSubmit: (program: string, timeMarkers: Array<any>) => void;
}

const KpiTrackerModal: React.FC<KpiTrackerProps> = ({
  kpiPrograms,
  handleSubmit,
}) => {
  const [selectedProgram, setSelectedProgram] = useState<string>('');
  const [isAdditionalTimeMarker, setIsAdditionalTimeMarker] = useState<boolean>(
    false,
  );
  const [additionalTimeMarker, setAdditionalTimeMarker] = useState<any>([
    {
      name: '',
      date: '',
    },
  ]);
  const [implemtationDate, setImplementationDate] = useState<string>('');

  const useStyles = makeStyles()({
    rootStyles: {
      width: '640px',
      justifyContent: 'center',
      gap: '20px',
      alignItems: 'center',
    },
    root: {
      width: '1182px',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
    inputWithDropdown: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '640px',
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      margin: '15px',
      justifyContent: 'space-between',
    },
    contentGrid: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      width: '640px',
      border: '1px solid' + patientAccessTheme.palette.grey[300],
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0px 20px 0px 10px',
      width: '100%',
      height: '56px',
      borderBottom: '3px dashed' + patientAccessTheme.palette.grey[300],
    },
    button: {
      width: '100%',
      display: 'flex',
      justifyContent: 'right',
    },
  });
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;

  const getKpiPrograms = () => {
    return kpiPrograms.map((item) => item.program);
  };

  const handleKpiCategory = (event: any) => {
    setSelectedProgram(event?.target?.value);
  };

  const handleAdditionalTimeMarker = () => {
    setIsAdditionalTimeMarker((prev: any) => !prev);
  };

  const handleTimeMarkerNameChange = (e: any, index: number) => {
    const value = e.target.value as string;
    setAdditionalTimeMarker((prev: any) => {
      const updatedTimeMarker = [...prev];
      updatedTimeMarker[index].name = value;
      return updatedTimeMarker;
    });
  };

  const handleTimeMarkerDateChange = (
     
    date: Date | null,
    index: number,
    value?: string | null,
  ) => {
    setAdditionalTimeMarker((prev: any) => {
      const updatedTimeMarker = [...prev];
      updatedTimeMarker[index].date = value;
      return updatedTimeMarker;
    });
  };

  const addAdditionalTimeMarker = () => {
    setAdditionalTimeMarker((prev: any) => {
      const updatedTimeMarker = [...prev];
      updatedTimeMarker.push({
        name: '',
        date: '',
      });
      return updatedTimeMarker;
    });
  };

  const handleImplementationDate = (
     
    date: Date | null,
    value?: any,
  ) => {
    setImplementationDate(value);
  };

  const isButtonDisabled = () => {
    const selectedProgramObj = kpiPrograms.find(
      (item) => item.program === selectedProgram,
    );
    if (selectedProgramObj) {
      for (const kpi of selectedProgramObj.Kpis) {
        if (kpi.selectedValues.length > 0) {
          return false;
        }
      }
    }
    return true;
  };
  return (
    <>
      <Grid className={classes.root}>
        <Grid
          container
          className={classes.rootStyles}
          sx={{
            flexDirection: 'column',
          }}
        >
          <Grid>
            <KpiTrackerIcon width={'140'} height={'100'} />
            <Typography
              fontSize="18px"
              fontType="semiBold"
              lineHeight="24.8px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {kpiTrackerMessages.pageContent.title}
            </Typography>
          </Grid>
          <Grid>
            <Grid
              className={classes.inputWithDropdown}
              style={{ background: patientAccessTheme.palette.grey[100] }}
            >
              <Box className={classes.box}>
                <Typography
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="regular"
                  fontSize="14px"
                  lineHeight="24px"
                >
                  {kpiTrackerMessages.pageContent.programTitle}
                </Typography>
              </Box>
              <Dropdown
                label={kpiTrackerMessages.pageContent.programLabel}
                dropDownOptions={getKpiPrograms()}
                dropDownValues={getKpiPrograms()}
                value={selectedProgram}
                handleChange={(event: any) => handleKpiCategory(event)}
                selectStyles={{
                  height: '38px',
                  '& >.MuiOutlinedInput-input': {
                    padding: '6px 16px',
                    fontSize: '12px',
                    lineHeight: '22.4px',
                    fontType: 'regular',
                    color: patientAccessTheme.palette.text.lowemphasis,
                  },
                  width: '300px',
                  marginRight: '30px',
                  backgroundColor: patientAccessTheme.palette.status.white,
                }}
              />
            </Grid>
            <Grid
              className={classes.inputWithDropdown}
              style={{ background: patientAccessTheme.palette.grey[100] }}
            >
              <Box className={classes.box}>
                <Typography
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="regular"
                  fontSize="14px"
                  lineHeight="24px"
                >
                  {kpiTrackerMessages.pageContent.dateImplementation}
                </Typography>
              </Box>
              <div style={{ marginRight: '30px' }}>
                <DatePicker
                  selectedDate={implemtationDate}
                  handleChange={handleImplementationDate}
                  minDate={`${employerGroupStore?.employerGroupResponseData?.start_month}-${employerGroupStore?.employerGroupResponseData?.start_year}`}
                  maxDate={`${employerGroupStore?.employerGroupResponseData?.end_month}-${employerGroupStore?.employerGroupResponseData?.end_year}`}
                  views={['year', 'month']}
                  format={'MMM-yyyy'}
                  placeholder={'(MMM-yyyy)'}
                />
              </div>
            </Grid>
            <Grid
              className={classes.inputWithDropdown}
              style={{ background: patientAccessTheme.palette.grey[100] }}
            >
              <Box className={classes.box}>
                <Typography
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="regular"
                  fontSize="14px"
                  lineHeight="24px"
                >
                  {kpiTrackerMessages.pageContent.additionalTimeMarkers}
                </Typography>
              </Box>
              <div style={{ marginRight: '30px' }}>
                <Switch
                  checked={isAdditionalTimeMarker}
                  handleChange={handleAdditionalTimeMarker}
                />
              </div>
            </Grid>
            {isAdditionalTimeMarker &&
              additionalTimeMarker?.map((item: any, index: number) => (
                <Grid
                  className={classes.inputWithDropdown}
                  style={{ background: patientAccessTheme.palette.grey[100] }}
                >
                  <Box className={classes.box}>
                    <TextField
                      width="250px"
                      height="38px"
                      placeholder={
                        kpiTrackerMessages.pageContent.timeMarkersPlaceholder
                      }
                      onChange={(e: any) =>
                        handleTimeMarkerNameChange(e, index)
                      }
                      value={item.name}
                    />
                  </Box>
                  <div
                    style={{
                      marginRight: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <DatePicker
                      selectedDate={item.date}
                      handleChange={(
                        date: Date | null,
                        value?: string | null,
                      ) => handleTimeMarkerDateChange(date, index, value)}
                      minDate={`${employerGroupStore?.employerGroupResponseData?.start_month}-${employerGroupStore?.employerGroupResponseData?.start_year}`}
                      maxDate={`${employerGroupStore?.employerGroupResponseData?.end_month}-${employerGroupStore?.employerGroupResponseData?.end_year}`}
                      views={['year', 'month']}
                      format={'MMM-yyyy'}
                      placeholder={'(MMM-yyyy)'}
                    />
                    <Add
                      style={{
                        height: '15px',
                        width: '15px',
                        cursor: 'pointer',
                      }}
                      fill={patientAccessTheme.palette.primary[500]}
                      onClick={addAdditionalTimeMarker}
                    />
                  </div>
                </Grid>
              ))}
            {selectedProgram !== '' && (
              <Grid className={classes.contentGrid}>
                <Grid className={classes.label}>
                  <Typography
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="medium"
                    fontSize="14px"
                    lineHeight="22.4px"
                  >
                    {kpiTrackerMessages.pageContent.kpiSelection}
                  </Typography>
                </Grid>

                <Grid
                  className={classes.inputWithDropdown}
                  style={{ flexWrap: 'wrap' }}
                  sx={{
                    flexDirection: 'column',
                  }}
                >
                  {kpiPrograms
                    .find((val) => val.program === selectedProgram)
                    ?.Kpis?.map((item, index) => (
                      <Grid
                        style={{ margin: '15px', gap: '10px', display: 'flex' }}
                        sx={{
                          flexDirection: 'column',
                        }}
                      >
                        <Grid direction="row">
                          <Box
                            className={classes.box}
                            style={{ margin: '0px' }}
                          >
                            <Typography
                              textColor={
                                patientAccessTheme.palette.text.highemphasis
                              }
                              fontType="medium"
                              fontSize="12px"
                              lineHeight="21.9px"
                            >
                              {item?.name + ' KPI'}
                            </Typography>
                            <Switch
                              checked={item?.isChecked ?? false}
                              handleChange={() =>
                                item.handleChange(selectedProgram, index)
                              }
                            />
                          </Box>
                        </Grid>
                        <AutocompleteWithCheckBoxes
                          options={item?.values}
                          defaultValue={item?.selectedValues}
                          handleChange={(event: any, value: any) => {
                            item?.handleSelectedValues(
                              selectedProgram,
                              index,
                              value,
                            );
                          }}
                          placeholder={
                            item?.selectedValues?.length === 0
                              ? kpiTrackerMessages.pageContent.kpiSelection
                              : ''
                          }
                          disabled={!item.isChecked}
                          width={'270px'}
                        />
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid className={classes.button}>
            <Button
              label={
                <Typography
                  textColor={patientAccessTheme.palette.status.white}
                  fontSize="16px"
                  lineHeight="24px"
                  fontType="semiBold"
                >
                  {kpiTrackerMessages.buttonText.submit}
                </Typography>
              }
              variant="contained"
              width="94px"
              height="44px"
              color="primary"
              borderRadius="4px"
              onClick={async () =>
                handleSubmit(
                  selectedProgram,
                  await combineTimeMarkers(
                    implemtationDate,
                    additionalTimeMarker,
                  ),
                )
              }
              disabled={isButtonDisabled()}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default KpiTrackerModal;
